import { render } from "./PdfGalleryModal.vue?vue&type=template&id=1ccbfdde&scoped=true&ts=true"
import script from "./PdfGalleryModal.vue?vue&type=script&lang=ts"
export * from "./PdfGalleryModal.vue?vue&type=script&lang=ts"

import "./PdfGalleryModal.vue?vue&type=style&index=0&id=1ccbfdde&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ccbfdde"]])

export default __exports__